<template>
    <div class="home-body-second">
        <!-- 商品展示区域 -->
        <div class="product-section">
            <!-- 左侧商品列表 -->
            <div class="product-list">
                <!-- 导航栏和搜索框合并到左侧商品列表顶部 -->
                <div class="product-header">
                    <!-- 分类导航 -->
                    <div class="category-nav">
                        <!-- <el-tabs v-model="activeFenleiName" @tab-click="handleFenleiClick" >
                            <el-tab-pane :label="item.label" :name="item.value" v-for="(item, index) in topList"
                                :key="index">
                            </el-tab-pane>
                        </el-tabs> -->
                        <el-tabs v-model="activeTopFenle" @tab-click="handleFenleiClick" style="width: 100%;">
                            <el-tab-pane label="全部" name="0"></el-tab-pane>
                            <el-tab-pane :label="item.name" :name="String(item.aid)" v-for="(item, index) in topList"
                                :key="index">
                            </el-tab-pane>
                        </el-tabs>
                    </div>

                    <!-- 商品搜索 -->
                    <div class="search-box">
                        <input type="text" placeholder="请输入关键词" class="search-input" v-model="keyword">
                        <button class="search-btn" @click="getSecondShopList">搜索</button>
                    </div>
                </div>

                <!-- 商品列表内容 -->
                <el-empty description="暂无数据" v-if="products.length == 0"></el-empty>
                <div class="product-items" v-else>
                    <div class="product-item" v-for="product in products" :key="product.id"
                        @click="goShopDetails(product)">
                        <div class="product-image">
                            <img :src="product.thumb" :alt="product.name">
                        </div>
                        <div class="product-info">
                            <div class="product-name">{{ product.name }}</div>
                            <div class="product-price-sales">
                                <div class="product-price">¥{{ product.shop_price }}/{{ product.unit }}</div>
                                <div class="product-sales">销量 {{ product.sales_sum }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 右侧商品推广 -->
            <div class="promotion-section">
                <div class="promotion-header">
                    <div class="promotion-title">商品推广</div>
                    <button class="publish-btn" @click="goTuiguang">+ 发布推广</button>
                </div>

                <div class="promotion-search">
                    <input type="text" placeholder="请输入关键词" class="promotion-search-input" v-model="keywords"
                        @keyup.enter="getShangjiaTuiGuang">
                    <button class="promotion-clear-btn" @click="getShangjiaTuiGuang">
                        <img src="../../assets/images/13.png" alt="">
                    </button>
                </div>

                <div class="promotion-list">
                    <el-empty description="暂无数据" v-if="promotions.length == 0"></el-empty>
                    <div class="promotion-item" v-for="item in promotions" :key="item.id" v-else
                        @click="goPromotionDetails(item)">
                        <div class="promotion-arrow">
                            <img src="../../assets/images/14.png" alt="" v-if="item.is_top == 1">
                        </div>
                        <div class="promotion-content-wrapper">
                            <div class="promotion-content">{{ item.title }}</div>
                            <div class="promotion-date">{{ item.create_time }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-text" @click="handleCategoryClick">
            <span>查看更多商品>></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeBodySecond',
    data() {
        return {
            activeTopFenle: '0',
            topList: [],
            products: [
            ],
            keyword: '',

            promotions: [
            ],
            keywords: '',
        }
    },
    props: {
        activeFenleiName: {
            type: [String, Number],
            default: '0'
        }
    },
    computed: {
        // 通过getter获取cityCode
        cityCode() {
            return this.$store.getters.getCityCode[1];
        }
    },
    watch: {
        activeFenleiName: {
            handler(newVal, oldVal) {
                // 重置 keyword 和 activeTopFenle，避免旧值干扰
                this.keyword = '';
                // 先获取分类列表，拿到默认第一个 aid 后再请求商品列表
                this.getCenterList().then(() => {
                    console.log('走的监听？', this.activeTopFenle);
                    this.getSecondShopList();
                });
            },
            immediate: true, // 组件初始化时立即执行一次（默认false）
            deep: false      // 是否深度监听（默认false，基础类型无需开启）
        },
        cityCode: {
            handler(newVal, oldVal) {
                this.getSecondShopList()
                this.getShangjiaTuiGuang()
            },
            immediate: false, // 组件初始化时立即执行一次（默认false）
            deep: false      // 是否深度监听（默认false，基础类型无需开启）
        }
    },
    mounted() {
        this.getShangjiaTuiGuang()
    },
    methods: {


        handleFenleiClick(tab, event) {
            console.log(tab, event);
            this.activeTopFenle = tab.name;
            this.getSecondShopList()

        },

        goShopDetails(product) {
            this.$router.push({
                path: '/ShopDetails',
                query: {
                    id: product.id
                }
            })
        },

        goTuiguang() {
            this.$router.push({
                path: '/FabuTuiguang',
            })
        },

        // 获取首页第二模块tabs数据
        getCenterList() {
            let data = {
                pid: this.activeFenleiName,
            }
            return this.$api.getCenterList(data).then(res => {
                let list = res || [];
                // 不在 topList 前插入"全部"，因为模板中已硬编码了"全部" tab（name="0"）
                this.topList = list;
                // 默认选中"全部"，cid 传 0 展示当前分类全部数据
                this.activeTopFenle = '0';
                console.log(this.activeTopFenle, 'activeTopFenle');
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 获取首页第二模块商品列表数据
        getSecondShopList() {
            let data = {
                goods_cid: this.activeFenleiName,
                cid: this.activeTopFenle,
                keyword: this.keyword,
                goods_type: 2,
                region_code: this.cityCode,
                page: 1,
                page_size: 8,
            }
            this.$api.getSecondShopList(data).then(res => {
                let list = res.data;
                this.products = list;
                console.log(this.products, 'products');

            }).catch(err => {
                this.$message.error(err);
            })
        },


        handleCategoryClick() {
            this.$emit('activeNameSecondClick', '2')
        },

        // 获取推广列表数据
        getShangjiaTuiGuang() {
            let data = {
                keywords: this.keywords,
                region_code: this.cityCode,
                page: 1,
                list_rows: 6,
            }
            this.$api.getShangjiaTuiGuang(data).then(res => {
                let list = res.data;
                this.promotions = list;
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 跳转推广详情页
        goPromotionDetails(item) {
            this.$router.push({
                path: '/TuiguangDetails',
                query: {
                    aid: item.aid
                }
            })
        },
    }
}
</script>

<style scoped>
.home-body-second {
    width: 1200px;
    margin: 20px auto;
    padding: 0 20px;
}

/* 商品展示区域 */
.product-section {
    display: flex;
    gap: 20px;
}

/* 商品列表 */
.product-list {
    flex: 1;
    display: flex;
    flex-direction: column;
}

/* 商品列表顶部（包含导航和搜索） */
.product-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    background-color: #ffffff;
    padding: 10px 20px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

/* 分类导航样式 */
.category-nav {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    border-radius: 0;
    width: 500px;
}

.nav-item {
    padding: 10px 20px;
    cursor: pointer;
    color: #333;
    font-size: 14px;
    transition: all 0.3s;
}

.nav-item:hover {
    color: #286CED;
}

.nav-item.active {
    color: #286CED;
    font-weight: bold;
    position: relative;
}

.nav-item.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 2px;
    background-color: #286CED;
    border-radius: 1px;
}

/* 搜索框样式 */
.search-box {
    display: flex;
    margin: 0;
    background-color: transparent;
    padding: 0;
    box-shadow: none;
    border-radius: 0;
}

.search-input {
    width: 200px;
    padding: 10px 15px;
    border: 1px solid #e0e0e0;
    border-radius: 4px 0 0 4px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.3s;
}

.search-input:focus {
    border-color: #286CED;
}

.search-btn {
    padding: 10px 20px;
    background-color: #286CED;
    color: white;
    border: none;
    border-radius: 0 4px 4px 0;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s;
}

.search-btn:hover {
    background-color: #2158c7;
}

/* 商品项容器 */
.product-items {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
}

.product-item {
    background-color: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    transition: all 0.3s;
    text-align: left;
}

.product-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.product-image {
    width: 100%;
    height: 180px;
    overflow: hidden;
}

.product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
}

.product-item:hover .product-image img {
    transform: scale(1.05);
}

.product-info {
    padding: 12px;
}

.product-name {
    font-size: 14px;
    color: #333;
    margin-bottom: 8px;
    height: 40px;
    overflow: hidden;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.product-price {
    font-size: 16px;
    color: #ff6b6b;
    font-weight: bold;
    margin-bottom: 4px;
}

.product-sales {
    font-size: 12px;
    color: #999;
}

/* 商品推广区域 */
.promotion-section {
    width: 280px;
    /* border: 1px solid #286CED; */
    /* 蓝色边框 */
    border-radius: 4px;
    padding: 0;
    background-color: #ffffff;
    box-shadow: none;
    /* 移除阴影 */
}

/* 推广区域头部 */
.promotion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    border-bottom: 1px solid #e0e0e0;
}

.promotion-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin: 0;
    padding: 0;
    border-bottom: none;
}

/* 发布推广按钮 */
.publish-btn {
    /* padding: 5px 10px; */
    font-weight: 500;
    font-size: 14px;
    color: #47A01A;
    border: none;
    background-color: #fff;
}

/* .publish-btn:hover {
    background-color: #2158c7;
} */

/* 推广搜索框 */
.promotion-search {
    display: flex;
    padding: 15px;
    border-bottom: 1px solid #e0e0e0;
}

.promotion-search-input {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-size: 12px;
    outline: none;
    position: relative;
}

.promotion-search-input:focus {
    border-color: #286CED;
}

/* 推广搜索框清除按钮 */
.promotion-clear-btn {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #999;
    font-size: 14px;
    padding: 0;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.promotion-clear-btn img {
    width: 16px;
    height: 16px;
    margin-right: 12px;
}

/* 推广搜索容器 */
.promotion-search {
    position: relative;
}

/* 推广列表 */
.promotion-list {
    padding: 10px 0;
}

/* 推广项 */
.promotion-item {
    display: flex;
    padding: 10px 0;
    margin: 0 15px;
    margin-bottom: 0;
    border-bottom: none;
    align-items: flex-start;
    border-bottom: 1px solid #e0e0e0;
}

/* 推广箭头 */
.promotion-arrow {
    color: #286CED;
    font-size: 14px;
    margin-right: 8px;
    margin-top: 2px;
}

.promotion-arrow img {
    width: 16px;
    height: 16px;
}

/* 推广内容包装器 */
.promotion-content-wrapper {
    flex: 1;
    text-align: left;
}

/* 推广内容 */
.promotion-content {
    font-size: 12px;
    color: #333;
    margin-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.5;
}

/* 推广日期 */
.promotion-date {
    font-size: 11px;
    color: #999;
}

/* 价格和销量样式 */
.product-price-sales {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

/* 响应式设计 */
@media (max-width: 1200px) {
    .home-body-second {
        width: 100%;
    }

    .product-items {
        grid-template-columns: repeat(3, 1fr);
    }

    .product-header {
        flex-direction: column;
        align-items: stretch;
        gap: 15px;
    }

    .category-nav {
        justify-content: center;
    }

    .search-box {
        justify-content: center;
    }

    .search-input {
        width: 300px;
    }
}

@media (max-width: 768px) {
    .product-section {
        flex-direction: column;
    }

    .promotion-section {
        width: 100%;
    }

    .product-items {
        grid-template-columns: repeat(2, 1fr);
    }

    .category-nav {
        flex-wrap: wrap;
    }

    .nav-item {
        padding: 8px 12px;
    }
}

.bottom-text {
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin-top: 32px;
}

/* 自定义Element UI标签页样式 */
::v-deep .el-tabs__header .is-top::after {
    background-color: transparent !important;
}
</style>